// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NXi_","left":"styles_left__3n5cr"};